var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopupDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 671,
    height: 2,
    viewBox: "0 0 671 2",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M671 1.00006L0 1",
    stroke: "url(#paint0_linear_577_185)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_577_185",
    x1: -334.37,
    y1: 0.999973,
    x2: 659.679,
    y2: 0.984746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.423197,
    stopColor: "#A279FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705038,
    stopColor: "#A279FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A279FA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupDivider);
export default __webpack_public_path__ + "static/media/popupDivider.6f6ce13b58395002c1518ea17418afbc.svg";
export { ForwardRef as ReactComponent };